import { useMutation, useQuery } from "react-query";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { ActionCreators } from "../../redux/Utilisateurs";
import Api, { IApi } from "../../services/Api";
import {
  FonctionPoste,
  PageUtilisateurs,
  Profil,
  Token,
  Utilisateur,
} from "../../services/Api/swagger";
import { getApiEndpoint } from "../../services/Config";

export const usePostUtilisateur = () => {
  const dispatch = useDispatch();
  const api: IApi = Api.create(getApiEndpoint());
  const navigate = useNavigate();
  return useMutation<Utilisateur, any, Utilisateur>(
    // @ts-ignore
    (params: Utilisateur) =>
      (api && api.ajouterUtilisateur(params)) || undefined,
    {
      onSuccess: (data: Utilisateur) => {
        dispatch(ActionCreators.ajouterUtilisateur.success(data));
        navigate("/mes-utilisateurs");
      },
      onError: (error, variables) => {
        dispatch(ActionCreators.ajouterUtilisateur.failure(error));
      },
    }
  );
};

export const useGetFonctionsPostes = () => {
  const api: IApi = Api.create(getApiEndpoint());
  const dispatch = useDispatch();
  return useQuery<FonctionPoste[]>(
    "fonctionsPoste",
    () => api && api.getFonctionsPostes(),
    {
      retry: false,
      onSuccess: (data) => {
        dispatch(ActionCreators.getFonctionsPostes.success(data));
      },
    }
  );
};

export const useGetUtilisateurByUsername = () => {
  const dispatch = useDispatch();
  const api: IApi = Api.create(getApiEndpoint());
  return useMutation<Utilisateur, any, string>(
    // @ts-ignore
    (params: string) =>
      (api && api.getUtilisateurByUsername(params)) || undefined,
    {
      onSuccess: (data: Utilisateur) => {
        dispatch(ActionCreators.getUtilisateurByUsername.success(data));
      },
      onError: (error, variables) => {
        dispatch(ActionCreators.getUtilisateurByUsername.failure(error));
      },
    }
  );
};

// export const useGetUtilisateurConnecteByUsername = () => {
//   const dispatch = useDispatch();
//   const api: IApi = Api.create(getApiEndpoint());

//   const { mutate: getProfilById, data: resultProfil } = useGetProfilById();
//   const navigate = useNavigate();
//   return useMutation<Utilisateur, any, string>(
//     // @ts-ignore
//     (params: string) =>
//       (api && api.getUtilisateurByUsername(params)) || undefined,
//     {
//       onSuccess: (data: Utilisateur) => {
//         dispatch(ActionCreators.getUtilisateurConnecteByUsername.success(data));

//         // const id =
//         //   data && data.detailAdbProfilSites
//         //     ? data.detailAdbProfilSites[0].profil
//         //     : data && data.profilBesse;
//         // if (id) {
//         //   getProfilById(id);

//         //   if (data) {
//         //     // Si l'on vient d'un lien qui contient l'url d'un dossier (après authentification) on redirige vers la synthèse
//         //     const refPath = new URLSearchParams(history.location.search).get(
//         //       "refDossier"
//         //     );
//         //     if (refPath) {
//         //       navigate("/dossier-location/synthese?refDossier=" + refPath);
//         //     } else if (data.role === UtilisateurRoleEnum.BESSE) {
//         //       // Si l'on est un admin BESSE on redirige vers la page adb
//         //       navigate("/mes-administrateurs-de-biens");
//         //     }
//         // }
//         //}
//       },
//       onError: (error, variables) => {
//         dispatch(ActionCreators.getUtilisateurByUsername.failure(error));
//       },
//     }
//   );
// };

// export const useGetProfilById = () => {
//   const dispatch = useDispatch();
//   const api: IApi = Api.create(getApiEndpoint());

//   return useMutation<Profil, any, number>(
//     // @ts-ignore
//     (params: number) => (api && api.getProfilById(params)) || undefined,
//     {
//       onSuccess: (data: Profil) => {
//         dispatch(ActionCreators.getProfil.success(data));
//       },
//       onError: (error, variables) => {
//         dispatch(ActionCreators.getProfil.failure(error));
//       },
//     }
//   );
// };
// export function* getUtilisateurConnecteByUsername(
//   api: IApi,
//   action: ActionType<
//     typeof ActionCreators.getUtilisateurConnecteByUsername.request
//   >
// ) {
//   try {
//     const result: Utilisateur = yield call(
//       api.getUtilisateurByUsername,
//       action.payload
//     );
//     yield put(ActionCreators.getUtilisateurConnecteByUsername.success(result));

//     const id = yield select(Selectors.getProfilId);

//     if (id) {
//       const profilResult: Profil = yield call(api.getProfilById, id);
//       yield put(ActionCreators.getProfil.success(profilResult));

//       if (result) {
//         // Si l'on vient d'un lien qui contient l'url d'un dossier (après authentification) on redirige vers la synthèse
//         const refPath = new URLSearchParams(history.location.search).get(
//           "refDossier"
//         );
//         if (refPath) {
//           yield put(push("/dossier-location/synthese?refDossier=" + refPath));
//         } else if (result.role === UtilisateurRoleEnum.BESSE) {
//           // Si l'on est un admin BESSE on redirige vers la page adb
//           yield put(push("/mes-administrateurs-de-biens"));
//         }
//       }
//     }
//   } catch (error) {
//     yield put(ActionCreators.getUtilisateurConnecteByUsername.failure(error));
//   }
// }

export const useGetProfilsBesse = () => {
  const dispatch = useDispatch();
  const api: IApi = Api.create(getApiEndpoint());
  return useMutation<Profil[], any, string>(
    // @ts-ignore
    (params: string) => (api && api.getProfilsBesse(params)) || undefined,
    {
      onSuccess: (data: Profil[]) => {
        dispatch(ActionCreators.getProfilsBesse.success(data));
      },
      onError: (error, variables) => {
        dispatch(ActionCreators.getProfilsBesse.failure(error));
      },
    }
  );
};

export const useGetAllUtilisateursBesse = () => {
  const dispatch = useDispatch();
  const api: IApi = Api.create(getApiEndpoint());
  return useMutation<
    PageUtilisateurs,
    any,
    {
      nom?: string | undefined;
      prenom?: string | undefined;
      statut?: string | undefined;
      page?: number | undefined;
      taille?: number | undefined;
      tri?: string | undefined;
    }
  >(
    // @ts-ignore
    (params: {
      nom?: string | undefined;
      prenom?: string | undefined;
      statut?: string | undefined;
      page?: number | undefined;
      taille?: number | undefined;
      tri?: string | undefined;
    }) => (api && api.getAllUtilisateursBesse(params)) || undefined,
    {
      onSuccess: (data: PageUtilisateurs) => {
        dispatch(ActionCreators.getAllUtilisateursBesse.success(data));
      },
      onError: (error, variables) => {
        dispatch(ActionCreators.getAllUtilisateursBesse.failure(error));
      },
    }
  );
};

export const useGetAllUtilisateursAdb = () => {
  const dispatch = useDispatch();
  const api: IApi = Api.create(getApiEndpoint());
  return useMutation<
    PageUtilisateurs,
    any,
    {
      numAdherent: number;
      nom?: string | undefined;
      prenom?: string | undefined;
      statut?: string | undefined;
      fonction?: string | undefined;
      page?: number | undefined;
      taille?: number | undefined;
      tri?: string | undefined;
    }
  >(
    // @ts-ignore
    (params: {
      numAdherent: number;
      nom?: string | undefined;
      prenom?: string | undefined;
      statut?: string | undefined;
      fonction?: string | undefined;
      page?: number | undefined;
      taille?: number | undefined;
      tri?: string | undefined;
    }) => (api && api.getAllUtilisateursAdb(params)) || undefined,
    {
      onSuccess: (data: PageUtilisateurs) => {
        dispatch(ActionCreators.getAllUtilisateursAdb.success(data));
      },
      onError: (error, variables) => {
        dispatch(ActionCreators.getAllUtilisateursAdb.failure(error));
      },
    }
  );
};

export const useDesactiverUtilisateur = () => {
  const dispatch = useDispatch();
  const api: IApi = Api.create(getApiEndpoint());
  return useMutation<void, any, string>(
    // @ts-ignore
    (params: string) => (api && api.desactiverUtilisateur(params)) || undefined,
    {
      onSuccess: (data: void, variables) => {
        dispatch(ActionCreators.desactiverUtilisateur.success());
        dispatch(
          ActionCreators.changerUtilisateurStatut({
            username: variables,
            actif: false,
          })
        );
      },
      onError: (error, variables) => {
        dispatch(ActionCreators.desactiverUtilisateur.failure(error));
      },
    }
  );
};

export const useActiverUtilisateur = () => {
  const dispatch = useDispatch();
  const api: IApi = Api.create(getApiEndpoint());
  return useMutation<void, any, string>(
    // @ts-ignore
    (params: string) => (api && api.activerUtilisateur(params)) || undefined,
    {
      onSuccess: (data: void, variables) => {
        dispatch(ActionCreators.activerUtilisateur.success());
        dispatch(
          ActionCreators.changerUtilisateurStatut({
            username: variables,
            actif: true,
          })
        );
      },
      onError: (error, variables) => {
        dispatch(ActionCreators.activerUtilisateur.failure(error));
      },
    }
  );
};

export const usePutUtilisateur = () => {
  const dispatch = useDispatch();
  const api: IApi = Api.create(getApiEndpoint());
  const navigate = useNavigate();
  return useMutation<
    void,
    any,
    {
      username: string;
      body: Utilisateur;
    }
  >(
    // @ts-ignore
    (params: { username: string; body: Utilisateur }) =>
      (api && api.modifierUtilisateur(params)) || undefined,
    {
      onSuccess: () => {
        dispatch(ActionCreators.modifierUtilisateur.success());
        navigate("/mes-utilisateurs");
      },
      onError: (error, variables) => {
        // dispatch(ActionCreators.modifierUtilisateur.failure(error));
      },
    }
  );
};

export const useActiverCompteUtilisateur = () => {
  const dispatch = useDispatch();
  const api: IApi = Api.create(getApiEndpoint());
  return useMutation<void, any, Token>(
    // @ts-ignore
    (params: Token) =>
      (api && api.activerCompteUtilisateur(params)) || undefined,
    {
      onSuccess: () => {
        dispatch(ActionCreators.activerCompteUtilisateur.success());
      },
      onError: (error, variables) => {
        dispatch(ActionCreators.activerCompteUtilisateur.failure(error));
      },
    }
  );
};
